// extracted by mini-css-extract-plugin
export default {"collectionCard":"CollectionTile_collectionCard__55Oxi","overlay":"CollectionTile_overlay__fMIOc"};